import React, { useState, useEffect } from 'react';
import { MegaphoneIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import api from '../../../services/api';
import { format } from 'date-fns';

const AnnouncementsWidget = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await api.get('/portal/announcements');
      setAnnouncements(response.data);
    } catch (error) {
      console.error('Error fetching announcements:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPriorityColor = (priority) => {
    const colors = {
      urgent: 'bg-red-100 text-red-800 border-red-200',
      high: 'bg-orange-100 text-orange-800 border-orange-200',
      normal: 'bg-blue-100 text-blue-800 border-blue-200',
      low: 'bg-gray-100 text-gray-800 border-gray-200'
    };
    return colors[priority] || colors.normal;
  };

  const getPriorityIcon = (priority) => {
    if (priority === 'urgent' || priority === 'high') {
      return <ExclamationTriangleIcon className="h-4 w-4" />;
    }
    return null;
  };

  if (loading) {
    return (
      <div className="portal-widget h-full">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="portal-widget h-full flex flex-col">
      <div className="portal-widget-header">
        <h3 className="portal-widget-title flex items-center">
          <MegaphoneIcon className="h-5 w-5 mr-2" />
          Announcements
        </h3>
      </div>

      <div className="flex-1 overflow-y-auto space-y-3 max-h-96">
        {announcements.length === 0 ? (
          <div className="text-center py-8 theme-text-secondary">
            <MegaphoneIcon className="h-12 w-12 mx-auto mb-3 opacity-50" />
            <p>No announcements at this time</p>
          </div>
        ) : (
          announcements.map((announcement) => (
            <div
              key={announcement.id}
              className="theme-bg-secondary rounded-lg p-4 border theme-border-primary hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between mb-2">
                <h4 className="font-semibold theme-text-primary flex-1">
                  {announcement.title}
                </h4>
                <span className={`text-xs px-2 py-1 rounded-full border flex items-center space-x-1 ${getPriorityColor(announcement.priority)}`}>
                  {getPriorityIcon(announcement.priority)}
                  <span>{announcement.priority}</span>
                </span>
              </div>

              <p className="theme-text-secondary text-sm mb-3 line-clamp-3">
                {announcement.content}
              </p>

              <div className="flex items-center justify-between text-xs theme-text-tertiary">
                <span>
                  By {announcement.creator_name || announcement.creator_email}
                </span>
                <span>
                  {format(new Date(announcement.created_at), 'MMM dd, yyyy')}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AnnouncementsWidget;
